(function () {
    const header = document.querySelector('.gh-header.has-background-image');

    header.style.setProperty('--services-height', `${services.offsetHeight}px`);
})();

(function () {
    pagination(true);
})();
